import { takeLatest, put, call } from "redux-saga/effects";
import { actions as transactionLinesActions } from "reducers/form/transactionLines";
import { actions as notificationActions } from "reducers/notification";
import { types, actions } from "reducers/files";
import * as fileMiddleware from "middleware/file";
import * as downloadUtil from "util/download";
import { b64toBlob } from "util/downloadMobile";

const sagas = [
    takeLatest(types.DOWNLOAD_FILE_REQUEST, downloadFileRequest),
    takeLatest(types.GET_FILE_CONTENTS_REQUEST, getFileContentsRequest),
    takeLatest(types.DOWNLOAD_FILE_TEMPLATE_REQUEST, downloadMassiveTemplate),
];

export default sagas;

function* downloadFileRequest({ idFile, fileName, idActivity }) {
    const fileResponse = yield call(fileMiddleware.downloadStream, idFile, idActivity);

    try {
        downloadUtil.downloadTransferTemplateCsvAsExcel(fileName, yield fileResponse.data.text());
    } catch (error) {
        // error al descargar archivo
    }

    // solo para quitar el descargando
    yield put(actions.downloadFileSuccess());
}

const fetchBlobData = async (url) => {
    let responseBlob;
    try {
        const response = await fetch(url);
        responseBlob = await response.blob();
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
    return responseBlob;
};

function* getFileContentsRequest({ idFile, deleteFile, idUserCreator, requestType, idActivity }) {
    let fileResponse;
    let blob;

    if (idUserCreator) {
        fileResponse = yield fileMiddleware.downloadStreamWithUser(idFile, idUserCreator, "load.echeq.massive");
        const base64 = fileResponse?.data?.data?.file?.contents;

        if (base64) {
            if (window.cordova) {
                blob = yield b64toBlob(base64, "application/octet-stream");
            } else {
                blob = yield fetchBlobData(`data:application/octet-stream;base64,${base64}`);
            }
        }
    } else {
        fileResponse = yield fileMiddleware.downloadStream(idFile, null, idActivity);
        const base64 = fileResponse?.data?.data?.file?.contents;

        if (base64) {
            blob = yield fetchBlobData(`data:application/octet-stream;base64,${base64}`);
        }

        blob = fileResponse.data;
    }

    const blobContent = yield downloadUtil.getBlobContent(blob);
    const content = yield downloadUtil.parseFileContent(blobContent, requestType, fileResponse);
    if (deleteFile) {
        yield fileMiddleware.deleteFile(Number(idFile));
    }

    yield put(transactionLinesActions.getFileContentsSuccess(content || []));
}

function* downloadMassiveTemplate({ idTemplate, nameFile, format, notificationScope }) {
    const response = yield call(fileMiddleware.downloadMassiveTemplate, {
        idTemplate,
        nameFile,
        format,
    });

    if (response.type === "W") {
        yield put(notificationActions.showNotification(response.data.message, "error", [notificationScope]));
        yield put({
            type: types.DOWNLOAD_FILE_TEMPLATE_FAILURE,
        });
    } else {
        yield put(notificationActions.showNotification(response.data.message, "success", [notificationScope]));
        const { fileName, content } = response.data.data;

        try {
            downloadUtil.downloadTransferTemplateCsvAsExcel(fileName, content);
        } catch (error) {
            // error al descargar archivo
        }

        yield put({
            type: types.DOWNLOAD_FILE_TEMPLATE_SUCCESS,
        });
    }
}
